import React from 'react';
import { lookupsJson } from '@ourbranch/lookups';
import { useFormikContext } from 'formik';

import { appConfig } from 'brand-config';
import { Tooltip } from 'core/components/tooltip';
import { FormField } from 'core/components/form';
import withDatePicker from 'core/components/with-date-picker';

import { getReasonOptions } from '../cancel-nonrenew-reasons';

// https://github.com/gobranch/branch/issues/21669
// NOTE (#33591): this list is legacy Branch/BIX codes only and does NOT include the standardized
// mutual codes (M****). That is correct today because this restriction only applies to OH/PA
// first-term *Auto* (`policyType === 'A'`), and the mutuals write only farm — so a mutual brand's
// reasons never reach this branch. If a mutual ever writes Auto in OH/PA, revisit which of the new
// codes must be excluded here for first-term compliance.
const optionsNotAllowedInPAandOHFirstTerm = ['NRAT', 'CNNR', 'NRLV', 'NRLS', 'NRFP'];

const NonRenewForm = () => {
  const { values } = useFormikContext();
  const { state, term, policyType } = values;

  const limitedNonRenewOptions = ['OH', 'PA'].includes(state) && term === 1 && policyType === 'A';

  // #33591: the visible non-renewal reasons come from the brand's enabled list when it declares one
  // (mutuals — Forreston/CFM/Oakwood), otherwise the legacy Branch/BIX non-renewal set.
  const baseNonRenewOptions = getReasonOptions({
    allReasons: lookupsJson.cancelReason,
    enabledReasonCodes: appConfig?.cancelNonRenewalReasons,
    kind: 'nonRenew'
  });

  const nonRenewOptions = limitedNonRenewOptions
    ? baseNonRenewOptions.filter((opt) => !optionsNotAllowedInPAandOHFirstTerm.includes(opt.id))
    : baseNonRenewOptions;

  return (
    <>
      <FormField
        name="nonRenewReason"
        type="select"
        label="Reason"
        mode="light"
        options={nonRenewOptions}
        xs={6}
        fast={false}
      />
      {limitedNonRenewOptions && (
        <Tooltip
          label="More Info"
          text="Non-renewal reasons are limited in the first term for Ohio and Pennsylvania."
        />
      )}
    </>
  );
};

export default withDatePicker(NonRenewForm);
